import MessengerPage from '.';

export const Messenger = () => <MessengerPage />;
